import {
  SUMMARY_DASHBOARD_ALL,
  SUMMARY_DASHBOARD_DELETE,
  SUMMARY_DASHBOARD_ERROR,
  SUMMARY_DASHBOARD_GET,
  SUMMARY_DASHBOARD_LOADING,
  SUMMARY_DASHBOARD_POST,
  SUMMARY_DASHBOARD_PUT,
} from '../../actions/types';

const initialState = {
  mmsDashboard: null,
  isLoading: true,
  isCompleted: true,
};

export default function SummaryDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case SUMMARY_DASHBOARD_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SUMMARY_DASHBOARD_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SUMMARY_DASHBOARD_POST:
      return { isLoading: false, isCompleted: true };
    case SUMMARY_DASHBOARD_PUT:
      return { isLoading: false, isCompleted: true };
    case SUMMARY_DASHBOARD_DELETE:
      return { isLoading: false, isCompleted: true };
    case SUMMARY_DASHBOARD_LOADING:
      return { isLoading: true, isCompleted: true };
    case SUMMARY_DASHBOARD_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
